import {AfterViewChecked, Component, Input} from '@angular/core';
import {CourseSection} from '../../models/course-section.model';
import {Lesson} from '../../models/lesson.model';
import {Breakpoints} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';
import {ResponsiveLayoutService} from '../../services/responsive-layout.service';
import {DataService} from '../services/data-service.service';
import {DurationPipe} from '../../shared/pipes/duration.pipe';
import {RouterLink} from '@angular/router';
import {MatExpansionModule} from '@angular/material/expansion';
import {NgFor, NgIf} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

type SectionLessons = {
  [p: string]: { sectionLessons: Lesson[]; sectionStartIndex: number };
};
@Component({
    selector: "course-list",
    templateUrl: "./course-list.component.html",
    styleUrls: ["./course-list.component.scss"],
    imports: [NgFor, MatExpansionModule, NgIf, RouterLink, DurationPipe, TranslateModule]
})
export class CourseListComponent implements AfterViewChecked {
  @Input()
  sections: CourseSection[];

  @Input()
  sectionLessons: SectionLessons;

  showExtraIcons: boolean;

  showLessonsListIcon: boolean;

  constructor(
    private responsive: ResponsiveLayoutService,
    private dataService: DataService) {

  }

  ngOnInit() {
    this.responsive
      .matchesAny(Breakpoints.HandsetPortrait, Breakpoints.TabletLandscape)
      .pipe(map(val => !val))
      .subscribe(matches => (this.showExtraIcons = matches));

    this.responsive
      .matchesAny(Breakpoints.HandsetPortrait, Breakpoints.TabletLandscape)
      .pipe(map(val => !val))
      .subscribe(matches => (this.showLessonsListIcon = matches));
  }

  getAllLessons() {
    return Object.values(this.sectionLessons).reduce((result, item) => {
      return result.concat(item.sectionLessons);
    }, [])
  }
  getSectionLessons() {
   return this.getAllLessons().slice(0, 4)
  }

  calculateSectionLength(section: CourseSection) {
    return this.sectionLessons[section.id].sectionLessons.length;
  }

  calculateAllLessonsLength() {
    return this.getAllLessons().length
  }

  ngAfterViewChecked() {
    this.dataService.emitViewChecked();
  }
}
